import { getIcon } from '@cheqroom/icons';
import { FC, Suspense, useState } from 'react';
import { twMerge } from 'tailwind-merge';

import { calculateColor, getInitials } from '../util';
import { avatar, getIconSize } from './Avatar.styles';
import type { AvatarProps } from './Avatar.types';

export const Avatar: FC<AvatarProps> = ({
	name = '',
	url,
	icon = 'User',
	color,
	type = 'circle',
	size,
	className,
	textClassName,
}) => {
	const [erroredUrl, setErroredUrl] = useState<string | null>(null);
	const { base, fallback, text } = avatar({ color: color ?? (name ? calculateColor(name) : 'indigo'), size, type });
	const IconComponent = getIcon(icon);
	const iconSize = getIconSize(size);

	return (
		<span className={twMerge(base(), fallback(), className)} title={name}>
			{name ? (
				<span className={text({ className: textClassName })}>{getInitials(name)}</span>
			) : (
				IconComponent && (
					<Suspense fallback={null}>
						<IconComponent width={iconSize} height={iconSize} />
					</Suspense>
				)
			)}
			{url && url !== erroredUrl && (
				<img
					alt={`Avatar for ${name}`}
					src={url}
					onError={() => setErroredUrl(url)}
					className="absolute inset-0 size-full object-cover"
				/>
			)}
		</span>
	);
};
